import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';
import { CustomerRaffleParsed, RaffleParsed, RaffleSettings, RafflePrize } from '@comsbi/common/src/types/models';

export { RaffleSettings, RaffleParsed, CustomerRaffleParsed, RafflePrize };

export type CustomerRaffle = Omit<CustomerRaffleParsed, 'raffle'> & { raffle: RaffleParsed };

const RaffleRepository = RepositoryFactory.get('raffle') as Repositories['raffle'];

const CHANNEL_ID: string =
  process.env.NODE_ENV === 'local' ? window.CHANNEL_ID || process.env.VUE_APP_CHANNEL_ID : window.CHANNEL_ID;

export const useRaffle = () => {
  /**
   * 指定スタンプカードマスターの顧客データを生成取得する
   */
  const resolve = async (raffleId: string): Promise<{ result: CustomerRaffle }> => {
    return (await RaffleRepository.resolveCustomerRaffle(raffleId)) as any;
  };

  const giveTicket = async (
    raffleId: string,
    numTickets: number,
    shopChannelId?: string
  ): Promise<{ result: { customerRaffle: CustomerRaffle; numTickets: number; shop: any } }> => {
    return (await RaffleRepository.giveTicket(raffleId, numTickets, shopChannelId)) as any;
  };

  const drawOnline = async (
    raffleId: string,
    numOfDraws: number
  ): Promise<{ result: { customerRaffle: CustomerRaffle; results: any[] /*抽選結果*/ } }> => {
    return (await RaffleRepository.drawOnline(raffleId, numOfDraws)) as any;
  };
  const drawOffline = async (
    raffleId: string,
    numOfDraws: number
  ): Promise<{ result: { customerRaffle: CustomerRaffle } }> => {
    return (await RaffleRepository.drawOffline(raffleId, numOfDraws)) as any;
  };

  const loadHistory = async (
    raffleId: string,
    offset: number,
    limit: number
  ): Promise<{ result: { history: any[] } }> => {
    return (await RaffleRepository.loadHistory(raffleId, offset, limit)) as any;
  };

  return {
    resolve,
    giveTicket,
    drawOnline,
    drawOffline,
    loadHistory,
  };
};

type RaffleType = ReturnType<typeof useRaffle>;
export const RaffleKey: InjectionKey<RaffleType> = Symbol('Raffle');
